<div class="outbound-events-container">
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading configuration...</p>
    </div>
  }

  @if (!isLoading) {
    <form [formGroup]="configForm" class="form-container">
      <div class="info-banner">
        <mat-icon>info</mat-icon>
        <div class="info-content">
          <strong>Campaign-level configuration overrides advertiser-level settings</strong>
          <p>Events will be forwarded based on this campaign's configuration.</p>
        </div>
      </div>
      <!-- Provider Selection -->
      <div class="form-row">
        <mat-form-field class="full-width">
          <mat-label>Provider</mat-label>
          <mat-select formControlName="provider">
            @for (provider of providers; track provider) {
              <mat-option [value]="provider">{{provider}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Segment Write Key -->
      @if (isProviderSegment) {
        <div class="form-row">
          <mat-form-field class="full-width">
            <mat-label>Segment Write Key</mat-label>
            <input matInput type="password" formControlName="writeKey" placeholder="Enter Segment write key">
            <mat-icon matPrefix>vpn_key</mat-icon>
            @if (configForm.get('writeKey')?.hasError('required')) {
              <mat-error>
                Write key is required
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      <!-- Webhook Configuration -->
      @if (isProviderWebhook) {
        <div>
          <div class="form-row">
            <mat-form-field class="full-width">
              <mat-label>Webhook Endpoint</mat-label>
              <input matInput type="url" formControlName="webhookEndpoint" placeholder="https://example.com/webhook">
              <mat-icon matPrefix>link</mat-icon>
              @if (configForm.get('webhookEndpoint')?.hasError('required')) {
                <mat-error>
                  Webhook endpoint is required
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field class="full-width">
              <mat-label>Security Key</mat-label>
              <input matInput type="password" formControlName="webhookSecurityKey" placeholder="Enter security key">
              <mat-icon matPrefix>vpn_key</mat-icon>
              @if (configForm.get('webhookSecurityKey')?.hasError('required')) {
                <mat-error>
                  Security key is required
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-row">
            <button type="button" mat-stroked-button color="accent" (click)="checkConnection()"
              [disabled]="isCheckingConnection || !configForm.get('webhookEndpoint')?.value || !configForm.get('webhookSecurityKey')?.value">
              @if (!isCheckingConnection) {
                <mat-icon>wifi_tethering</mat-icon>
              }
              @if (isCheckingConnection) {
                <mat-spinner diameter="20"></mat-spinner>
              }
              Check Connection
            </button>
          </div>
        </div>
      }
      <!-- Event Types Selection -->
      @if (!isProviderNone) {
        <div class="form-row">
          <label class="section-label">Subscribed Event Types</label>
          <p class="helper-text">Select which event types should be forwarded for this
          campaign</p>
          <mat-form-field class="full-width chips-field">
            <mat-label>Event Types</mat-label>
            <mat-chip-grid #chipGrid aria-label="Event type selection">
              @for (eventType of selectedEventTypes; track eventType) {
                <mat-chip-row (removed)="removeEventType(eventType)"
                  [editable]="false">
                  {{eventType}}
                  <button matChipRemove [attr.aria-label]="'remove ' + eventType">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
            </mat-chip-grid>
            <input #eventTypeInput [formControl]="eventTypeControl" placeholder="Type to add event types..."
              [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addEventType($event)" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onEventTypeSelected($event.option.value)">
              @for (eventType of filteredEventTypes | async; track eventType) {
                <mat-option [value]="eventType">
                  {{eventType}}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          @if (eventTypesTouched && selectedEventTypes.length === 0) {
            <p class="error">At least one event type is required *</p>
          }
          @if (availableEventTypes.length > 0) {
            <div class="event-types-list">
              <p class="helper-text"><strong>Available Event Types:</strong></p>
              <div class="event-type-chips">
                @for (eventType of availableEventTypes; track eventType) {
                  <button type="button" mat-stroked-button
                    [disabled]="selectedEventTypes.includes(eventType)" (click)="addEventTypeFromList(eventType)"
                    class="event-type-chip">
                    {{eventType}}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
    </form>
  }
</div>